import React from "react";
import { FontAwesomeIcon } from "../../../../CommonComponents/AssetsHelper";
import { Button } from "react-bootstrap";

const Expensive = ({acceptOfferSubscription, offerRequest}) => {
    return (
        <div className="p-5 bg-gray rounded">
            <div className="text-center">
                <p className="my-4">
                    <FontAwesomeIcon type={'solid'} icon={'gift'} iconClass={'display-1'} />
                </p>
                <p>We understand cost is important and we want to ensure that our services are beneficial for all our customer's journeys.</p>
                <h3 className="mb-8">Hence, we would like to offer you an exclusive 10% discount on your next billing cycle. Claim Now!</h3>
                <Button variant="primary" className={`${offerRequest ? 'spinner spinner-right disabled' : ''}`} onClick={() => acceptOfferSubscription() }>Accept This Offer</Button>
            </div>
        </div>
    )
}

export default Expensive;